<template>
  <div class="bg position-relative">
    <div class="background-top">
      <div class="bc">
        <img class="img_1" src="/img/image/home/t_9.png" loading="lazy" alt="關注我們">
        <div class="space"/>
        <Glide :glide-item-type="glideItemType" :htmlArray="htmlArray"/>
        <div class="down_space"/>
      </div>
    </div>
  </div>
</template>

<script>
import * as GlideItemType from '../../shared/glide_item_type'
import Glide from "../../components/Glide";
import GlideItem from "../../components/GlideItem/GlideItem";

export default {
  name: "Stage_4",
  components: {Glide, GlideItem},
  computed: {
    glideItemType() {
      return GlideItemType.followUs;
    },
  },
  data() {
    return {
      htmlArray: [
        {
          imgUrl: "/img/image/home/ig_img1.png",
        },
        {
          imgUrl: "/img/image/home/ig_img2.png",
        },
        {
          imgUrl: "/img/image/home/ig_img3.png",
        },
        {
          imgUrl: "/img/image/home/ig_img4.png",
        },
        {
          imgUrl: "/img/image/home/ig_img5.png",
        },
      ]
    };
  },
}
</script>

<style lang="scss" scoped>

.bg {
  background-image: url('/img/image/background/bg_s5.png');
  background-size: cover; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: no-repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
}
@media (max-width: 576px) {
  .bc {
    text-align: center;
  }
}


// 文字 關注我們
.img_1 {
  padding-top: 72px;
  padding-left: 87px;
  width: 300px;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
}

@media (max-width: 576px) {
  .img_1 {
    padding-top: 42px;
    padding-left: 0;
    width: 180px;
  }
}


.space {
  height: 55px;
}

@media (max-width: 576px) {
  .space {
    height: 47px;
  }
}
.down_space{
  height: 65px;
}

</style>

